export const JockeySilks = {
    1: {
        silkCourseName: 'BDP'
    },
    2: {
        silkCourseName: 'DBVL',
    },
    3: {
        silkCourseName: 'FAIR(P)',
    },
    4: {
        silkCourseName: 'FAIR(T)',
    },
    5: {
        silkCourseName: 'FLPK',
    },
    6: {
        silkCourseName: 'GREY(P)',
    },
    7: {
        silkCourseName: 'GREY(T)',
    },
    8: {
        silkCourseName: 'KENW',
    },
    9: {
        silkCourseName: 'MAUR',
    },
    10: {
        silkCourseName: 'SCOT(I)',
    },
    11: {
        silkCourseName: 'SCOT',
    },
    12: {
        silkCourseName: 'TURF(S)',
    },
    13: {
        silkCourseName: 'TURF(I)',
    },
    14: {
        silkCourseName: 'VAAL(T)',
    },
    15: {
        silkCourseName: 'VAAL(C)',
    }
};
